import { render, staticRenderFns } from "./partnerDetail.vue?vue&type=template&id=2ae7c356&scoped=true&"
import script from "./partnerDetail.vue?vue&type=script&lang=js&"
export * from "./partnerDetail.vue?vue&type=script&lang=js&"
import style0 from "./partnerDetail.vue?vue&type=style&index=0&id=2ae7c356&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae7c356",
  null
  
)

export default component.exports